import { render, staticRenderFns } from "./ApplianceTable.vue?vue&type=template&id=d908b1f6&"
import script from "./ApplianceTable.vue?vue&type=script&lang=js&"
export * from "./ApplianceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports